import {createSlice} from '@reduxjs/toolkit';

import {
  serviceGetCredentials,
  serviceGetInventories,
  serviceGetExecuteFileData,
  serviceGetConfigFiles,
  servicePostMacro,
} from 'utils';


const initialState = {
  data: null,
  isLoaded: {
    fieldData: false,
    post: false,
    get: false,
    getExecuteFileData: false,
  },
  success: {
    fieldData: false,
    post: false,
    get: false,
    getExecuteFileData: false,
  },
  error: {
    fieldData: false,
    post: false,
    get: false,
    getExecuteFileData: false,
  },
  fieldData: {
    credentials: [],
    inventories: [],
    configFiles: [],
  },
}

const MacroSlice = createSlice({
  name: 'macro',
  initialState,
  reducers: {

    getFieldDataSuccess(state, action) {
      const data = action.payload;
      const configFiles =  [...data[2].map((i) => ({ value: i, label: i }))]
      const oldVersionApi = JSON.parse(process.env.REACT_APP_OLD_VERSION_API || false) || false;
      let inventories = [];
      let credentials = [];

      if (oldVersionApi) {
        inventories = [ ...data[1].list_files.map((i) => ({ value: i, label: i })) ];

        credentials = [
          { value: 0, label: 'common.rules.empty' },
          ...data[0].map((i) => ({ value: i.credentials_id, label: i.name })),
        ];

      } else {
        inventories = [ ...data[1].map((i) => ({ value: i.name, label: i.name })) ];

        credentials = [
          { value: 0, label: 'common.rules.empty' },
          ...data[0].map((i) => ({ value: i.credential_id, label: i.name })),
        ];
      }


      return {
        ...state,
        isLoaded: { ...state.isLoaded, fieldData: false },
        success: { ...state.success, fieldData: true },
        fieldData: {
          credentials,
          inventories,
          configFiles
        },
      };
    },


    getFieldDataRequest(state, action) {
      return { ...state, isLoaded: { ...state.isLoaded, fieldData: true } };
    },

    getFieldDataFailure(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, fieldData: false },
        error: { ...state.error, fieldData: action.payload.message },
      };
    },


    dataRequest(state, action) {
      return { ...state, isLoaded: { ...state.isLoaded, [action.payload]: true } };
    },

    dataSuccess(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        success: { ...state.success, [action.payload.fetchType]: true },
        data: action.payload.data || null,
      };
    },

    dataFailure(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        error: { ...state.error, [action.payload.fetchType]: action.payload.data?.message },
      };
    },

    cleanUpMacro() {
      return initialState;
    },

    cleanUpMessageMacro(state) {
      return {
        ...state,
        isLoaded: initialState.isLoaded,
        success: initialState.success,
        error: initialState.error,
      };
    },

    cleanUpDataFieldMacro(state) {
      return {
        ...state,
        fieldData: {
          credentials: [],
          inventories: [],
          configFiles: []
        },
      };
    },

  }
});

const {
  getFieldDataSuccess,
  getFieldDataRequest,
  getFieldDataFailure,
  dataRequest,
  dataSuccess,
  dataFailure,
  cleanUpMacro,
  cleanUpMessageMacro,
  cleanUpDataFieldMacro
} = MacroSlice.actions;


const fetchGetExecuteFileData = (query) => {
  return (dispatch) => {
    dispatch(dataRequest('getExecuteFileData'));
    serviceGetExecuteFileData(query)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'getExecuteFileData'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'getExecuteFileData'})));
  };
};

const fetchGetFieldData = (args) => {
  return (dispatch) => {
    dispatch(cleanUpDataFieldMacro());
    dispatch(getFieldDataRequest());
    Promise.all([
      serviceGetCredentials(args),
      serviceGetInventories(args),
      serviceGetConfigFiles(),
    ])
      .then((response) => {
        const resultResponse = response.map((res) => res.data);
        dispatch(getFieldDataSuccess(resultResponse));
      })
      .catch((err) => dispatch(getFieldDataFailure(err)));
  };
};

const fetchPostMacro = (body) => {
  return (dispatch) => {
    dispatch(dataRequest('post'));
    servicePostMacro(body)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'post'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'post'})));
  };
};


export {
  fetchGetExecuteFileData,
  fetchPostMacro,
  cleanUpMacro,
  cleanUpMessageMacro,
  fetchGetFieldData,
  cleanUpDataFieldMacro,
};

export default MacroSlice.reducer;
